import React from 'react';
import ReactDOM from 'react-dom';
import { Button } from "@material-ui/core";

function CTAButton(props) {
    const ctaRef = React.useRef();

    React.useEffect(() => {
        const hubspotScript = document.createElement('div');
        hubspotScript.innerHTML = "<script charset=“utf-8” src=“https://js.hscta.net/cta/current.js”></script><script type=“text/javascript”> hbspt.cta.load(2430240, ‘b4c8b61e-ccca-4fbf-a1bb-69aee967df9b’, {}); </script>";

        const ctaContainer = ReactDOM.findDOMNode(ctaRef.current);
        ctaContainer.appendChild(hubspotScript);
    });

    return (
        <Button className={props.className} size={props.size} variant={props.variant} ref={ctaRef} href="https://cta-redirect.hubspot.com/cta/redirect/2430240/b4c8b61e-ccca-4fbf-a1bb-69aee967df9b" target="_blank">
            {props.children}
        </Button>
    );
}

export default CTAButton;